// extracted by mini-css-extract-plugin
export default {"heading":"Heading_heading__1PLoy","text--1":"Heading_text--1__opaaK","text--2":"Heading_text--2__eYYxO"};